import React from 'react';
import './WorkDetailsTop.css';

const WorkDetailsTop = ({ image, title, shortdescription }) => {
    const imagePath = `/${image}`

    return (
        <div className="work-details-top-component">
            <img src={imagePath} alt={title} />
            <div className="content-work-details-top">
                <h2 className='work-details-top-component-title'>{title}</h2>
                <p className='work-details-top-component-shortdescription'>{shortdescription}</p>
            </div>
        </div>
    );
};

export default WorkDetailsTop;
